// extracted by mini-css-extract-plugin
export default {"productRow":"ProductRow_productRow__nnler","compactRow":"ProductRow_compactRow__CnTWh"};